import {LIST_OF_GAME_DATA_API} from "../constants/api_constants";
import {getFetcherEB} from "./fetcher_eb";

class NeverLandGameDataCommon {
  sortTicketData(_ticketData) {
    // <-- 경기번호 순서대로 정렬 -->
    for (let ticket of _ticketData) {
      ticket.selectGame.sort((t1, t2) => {
        return t1.allotId.localeCompare(t2.allotId);
      })
    }
  }

  getRatingValue(card) {
    // 경기 개수에 따른 배당 구하기
    let selectedAllotData = card.selectGame;
    if (selectedAllotData.length === 1)
      return selectedAllotData[0].rate;

    let ratingValue = 1;
    for (const item of selectedAllotData) {
      ratingValue *= item.rate;
    }
    ratingValue = Math.floor(ratingValue * 100) / 100;
    ratingValue = Math.ceil(ratingValue * 10) / 10;
    return ratingValue;
  }

  getPrediction = (gameNumber, prediction, category) => {
    let _prediction = prediction;
    // <-- 언더/오버 일때 승,패 대신 언더/오버 -->
    if (gameNumber.includes('U')) {
      if (prediction === '승') _prediction = '언더';
      if (prediction === '패') _prediction = '오버';
    }

    // <-- 홀/짝 일때 승,패 대신 홀/짝 -->
    if (gameNumber.includes('⒮')) {
      if (prediction === '승') _prediction = '홀';
      if (prediction === '패') _prediction = '짝';
    }

    // <-- 전반일때 앞에 (전) 붙이기 -->
    if (category === "type01") return `(전)${_prediction}`;

    return _prediction;
  }

}
const neverLandGameDataCommon = new NeverLandGameDataCommon();
export default neverLandGameDataCommon;